

import { mapGetters } from 'vuex';

import { parser, Schedules } from '@sopheos/orbjs/opening_hour';

export default {
  name: 'SSchedule',
  props: {
    schedules: {
      type: String,
      required: true,
    },
    admin: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      previewSchedule: {},
      concateSchedule: {},
      hasGlobal: false,
      hasMonth: false,
      hasPeriod: false,
      // dialog
      showDialog: false,
      // TODO WORDING
      dialogTitle: 'Les horaires',
      dialogLabel: 'Toutes les horaires',
      dialogOptions: {
        scrollable: true,
      },
      dialogButtons: {
        closeText: 'Fermer',
        confirmText: 'Éditer',
        confirmColor: 'info',
      },
      panelIndex: [],
      currentIndex: null,

    };
  },
  computed: {
    ...mapGetters({
      getCurrentDate: 'transferData/getCurrentDate',
    }),
  },
  watch: {
    schedules: {
      immediate: true,
      handler() {
        const schedules = parser(this.schedules, this.getCurrentDate);
        const scheduleHelper = new Schedules(schedules, this.getCurrentDate, this.admin);
        this.previewSchedule = scheduleHelper.getPreview();
        this.concateSchedule = scheduleHelper.getConcat();
        this.hasGlobal = this.concateSchedule.global.some((groupDay) => groupDay.times);
        this.hasMonth = this.concateSchedule.months.some((groupMonth) => groupMonth.week);
        this.hasPeriod = !!this.concateSchedule.periods.length;
      },
    },
  },
  methods: {
    openForm() {
      this.showDialog = false;
      this.$emit('open-form');
    },
  },
};

